/*
  Fluxonix Settings Fetching Hook
  (c) 2025 Fluxonix Inc.
*/

// hooks/usePublicSettings.js
import { useEffect, useState } from "react";
import { api } from "../api";

export function usePublicSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get("/api/public/settings"); // ✅ use raw axios
        setSettings(res.data);
      } catch (err) {
        console.error("Failed to fetch public settings", err);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { settings, loading };
}